import { Button, type ButtonProps } from "../../inputs/button";
import { cn } from "../../utils";

/** Trigger button shared by the task property pickers (status, priority, assignee, dates). */
export function PropertyTrigger({ className, ...props }: Omit<ButtonProps, "variant">) {
  return (
    <Button
      variant="ghost"
      className={cn(
        "h-auto min-h-0 min-w-0 max-w-full justify-start gap-2 border border-border bg-background px-2 py-0.5 has-[>svg]:px-2 text-sm font-normal hover:bg-muted/60",
        className,
      )}
      {...props}
    />
  );
}
